var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "border_color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2368_8853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: -0.833008,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2368_8853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "border_color_2",
    d: "M1.66602 19.1673V15.834H18.3327V19.1673H1.66602ZM4.99935 12.5006H6.16602L12.666 6.02148L11.4785 4.83398L4.99935 11.334V12.5006ZM3.33268 14.1673V10.6257L12.666 1.31315C12.8188 1.16037 12.9959 1.04232 13.1973 0.958984C13.3987 0.875651 13.6105 0.833984 13.8327 0.833984C14.0549 0.833984 14.2702 0.875651 14.4785 0.958984C14.6868 1.04232 14.8744 1.16732 15.041 1.33398L16.1869 2.50065C16.3535 2.65343 16.475 2.83398 16.5514 3.04232C16.6278 3.25065 16.666 3.46593 16.666 3.68815C16.666 3.89648 16.6278 4.10135 16.5514 4.30273C16.475 4.50412 16.3535 4.68815 16.1869 4.85482L6.87435 14.1673H3.33268Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.35d7a7ef6e8965b68b88c94684bb9050.svg";
export { ForwardRef as ReactComponent };